import * as React from 'react'
import styled from 'styled-components'

export const ConnectionVariablesDescription = () => {
  return (
    <Variables>
      <b>利用可能な変数:</b>
      <b>基本情報:</b>
      <VariablesList>
        <dt>[date]</dt>
        <dd> 催行日 （US英語形式 例: 31st Oct）</dd>
        <dt>[start_date]</dt>
        <dd> 催行日 （例: 2025/10/31(Fri.)）</dd>
        <dt>[start_time]</dt>
        <dd> ツアー開始時刻 （例: 10:30）</dd>
        <dt>[time]</dt>
        <dd> ツアー時間帯 （例: 10:30-14:30(4 hours)）</dd>
        <dt>[seller_booking_id]</dt>
        <dd> OTA予約番号 （例: GYG-XXXXX, RE-XXXXXXX）</dd>
      </VariablesList>
      <b>ツアー詳細:</b>
      <VariablesList>
        <dt>[post_name]</dt>
        <dd> ツアー名</dd>
        <dt>[duration]</dt>
        <dd> ツアー時間 （例: 4, 8 等）</dd>
        <dt>[area]</dt>
        <dd> 地域 （例: Tokyo, Kyoto）</dd>
      </VariablesList>
      <b>場所情報:</b>
      <VariablesList>
        <dt>[meetup_place]</dt>
        <dd> 集合場所 （カスタム指定または登録済み場所）</dd>
        <dt>[meetup_url]</dt>
        <dd> 集合場所URL</dd>
      </VariablesList>
      <b>ガイド情報:</b>
      <VariablesList>
        <dt>[guide_name]</dt>
        <dd> ガイド名（ユーザー名）</dd>
        <dt>[guide_email]</dt>
        <dd> ガイドメールアドレス</dd>
      </VariablesList>

      <b>ゲスト情報:</b>
      <VariablesList>
        <dt>[guest_name]</dt>
        <dd> ゲスト名</dd>
        <dt>[num_of_people]</dt>
        <dd> ゲスト人数</dd>
        <dt>[message]</dt>
        <dd> ゲストからの追加リクエスト</dd>
      </VariablesList>
    </Variables>
  )
}

const Variables = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`

const VariablesList = styled.dl`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  dt {
    width: 30%;
    font-weight: bold;
  }
  dd {
    width: 70%;
  }
`
